import React from 'react';
import { Link } from 'react-router-dom';
// import "../../Components-Pages/Home/Home.css"
import './ProfileBox.css';

function ProfileBox(props) {
  return (
    // <div className="availability-table  top-floor-row-table-1 profile-qualification-container gray-shadow-box">
    <div className={'profile-box ' + props.header.replace(/\s/g, '-').toLowerCase()}>
      <div className='compliments-header-bckg'>
        <h4 className={
          ((props.smallHeader) ? 'qualifications-card-title-small' : 'qualifications-card-title')
        }>
          {props.header.toUpperCase()}
        </h4>
      </div>

      <div
        className={
          'profile-box-inner' +
          (props.topUpcomingClass && !props.children
            ? ' top-profile-box-inner'
            : '')
        }
      >
        {props.children || (
          <div className='profile-box-empty'>
            <div className='text-left ml-3'>
              No information available
            </div>
            {props.header === 'Upcomzing Class' && (
              <div className='see-job-list-new'>
                <br />
                <br />
                <Link to='/TeacherJobList'> See Job List{' >>'}</Link>
              </div>
            )}
            {props.header === 'Upcoming Booking' && (
              <div className='see-job-list-new'>
                <br />
                <br />
                <Link to='/CollegeJobList'> See Job List{' >>'}</Link>
              </div>
            )}
            {props.header === 'Last Completed' && (
              <div className='see-job-list-new'>
                <br />
                <br />
                <Link to='/CollegeJobList'> See Job List{' >>'}</Link>
              </div>
            )}
          </div>
        )}
      </div>
      {props.seeResumeFooter}
      {props.footer ? (
        <>
          <hr className='qualification-line-2'/>
          <div className='profile-box-footer'>{props.footer}</div>
        </>
      ) : null}
    </div>
  );
}

export default ProfileBox;
